import gql from 'graphql-tag';
import { LabelFragment } from '@app/pages/settings/graphql/labels.queries';

export const CreateLabelMutation = gql`
	mutation CreateLabelMutation(
		$color: String
		$name: String!
		$parentId: UUID
		$type: LabelTypeEnum = LABEL
	) {
		createLabel(color: $color, name: $name, parentId: $parentId, type: $type) {
			label {
				...LabelFragment
			}
			success
		}
	}
	${LabelFragment}
`;

export const EditLabelMutation = gql`
	mutation EditLabelMutation(
		$pk: UUID!
		$name: String
		$color: String
		$parentId: UUID
		$type: LabelTypeEnum
	) {
		editLabel(pk: $pk, name: $name, color: $color, parentId: $parentId, type: $type) {
			label {
				...LabelFragment
			}
		}
	}
	${LabelFragment}
`;

export const DeleteLabelMutation = gql`
	mutation DeleteLabelMutation($pk: UUID!) {
		deleteLabel(pk: $pk) {
			success
		}
	}
`;
